export const tempAll = 'rgba(253, 208, 159, 0.7)';
export const tempDay = 'rgba(251, 227, 142, 0.7)';
export const tempNight = 'rgba(154, 137, 255, 0.7)';
export const tempWater = 'rgba(169, 244, 208, 0.7)';
export const humidity = 'rgba(174, 201, 254, 0.7)';
export const precipitation = 'rgba(219, 174, 255, 0.7)';
export const windSpeed = 'rgba(154, 137, 255, 0.7)';
export const windGust = 'rgba(254, 174, 174, 0.7)';
export const atmosphericPressure = 'rgba(253, 208, 159, 0.7)';
